<template>
  <v-container class="no-margins">
    <ActionButton class="mt-4" actionIcon="$sl-password-type" @click="doPasswordLogin()">{{ buttonText }}</ActionButton>
  </v-container>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'PasswordLoginButton',

  props: {
    buttonText: {
      type: String,
      required: true
    }
  },

  components: {
    ActionButton
  },

  methods: {
    doPasswordLogin() {
      this.$nextTick(() => {
        this.$router.push({
          name: 'Login'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>